import { render, staticRenderFns } from "./hsbcstemupUpload.vue?vue&type=template&id=53b19d85"
import script from "./hsbcstemupUpload.vue?vue&type=script&lang=js"
export * from "./hsbcstemupUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports